import React from 'react';

const Equipment = ({equipmentName}) =>{
	return(
		<li>{equipmentName}</li>
	)
}

export default Equipment;
